import request from "@/utils/request";

// 获取所有面板
export function getAllPanel(data) {
  return request({
    url: "/v3/iw-framework/panel/get-all",
    method: "POST",
    data: { data }
  });
}

// 自定义面板
export function setMyPanel(data) {
  return request({
    url: "/v3/iw-framework/panel/set-panel",
    method: "POST",
    data: { data }
  });
}

// 查询自定义的面板
export function getMyPanel(data) {
  return request({
    url: "/v3/iw-framework/panel/my-panel",
    method: "POST",
    data: { data }
  });
}

// 获取整体统计数
export function getPvSalesIndex() {
  // return request({
  //   url: "/app-dashboard/overview/pvSales/pv-sales-index",
  //   method: "post",
  //   data: { data }
  // });
  return request({
    url: "/v3/iw-sales-analysis/overview/get-pv-sales",
    method: "get"
  });
}

// 获取新嫩官统计数
export function getEnergySalesIndex() {
  // return request({
  //   // url: "/app-dashboard/overview/pvSales/energy-sales-index",
  //   method: "post",
  //   data: { data }
  // });
  return request({
    url: "/v3/iw-sales-analysis/overview/get-energy-sales",
    method: "get"
  });
}

// 获取整体市场echart
export function getPvSalesChart() {
  // return request({
  //   url: "/app-dashboard/overview/pvSales/pv-sales-chart",
  //   method: "post",
  //   data: { data }
  // });
  return request({
    url: "/v3/iw-sales-analysis/overview/get-pv-sales-trend",
    method: "get"
  });
}

// 获取新能源市场echart
export function getEnergySalesChart(data) {
  return request({
    url: "/app-dashboard/overview/pvSales/energy-sales-chart",
    method: "post",
    data: { data }
  });
}

// 获取厂商排行
export function getManfRankList() {
  // return request({
  //   url: "/app-dashboard/overview/salesRank/manf-rank-list",
  //   method: "post",
  //   data: { data }
  // });

  return request({
    url: "/v3/iw-sales-analysis/overview/list-manf-sales",
    method: "get"
  });
}

// 获取车型排行
export function getSubmodelRankList(data) {
  // return request({
  //   url: "/app-dashboard/overview/salesRank/submodel-rank-list",
  //   method: "post",
  //   data: { data }
  // });
  return request({
    url: "/v3/iw-sales-analysis/overview/list-subModel-sales",
    method: "post",
    data: { data }
  });
}

// 获取新车
export function getNewCar(data) {
  // return request({
  //   url: "/app-dashboard/overview/other/new-car-launchs",
  //   method: "post",
  //   data: data
  // });
  return request({
    url: "/new-car/index/coming-soon-model",
    method: "post",
    data: data
  });
}

// 获取新闻
export function getNewsRecommend(data) {
  return request({
    url: "/news/news/recommend",
    method: "get",
    data: { data }
  });
}

// 获取新闻 新接口
export function getPublicNews() {
  // return request({
  //   url: "/news/news/ways-public-news",
  //   method: "get",
  //   params: data
  // });
  return request({
    url: "/evnews-api/news/list-news",
    method: "post",
    data: {
      data: {
        newsType: 1,
        newsId: null,
        newsPushChannelId: 12,
        page: 1,
        pageSize: 3
      }
    }
  });
}

// 获取政策
export function getHostPolicy(data) {
  return request({
    url: "/app-dashboard/overview/other/host-policy",
    method: "post",
    data: { data }
  });
}

// 获取价值指标
export function getPriceIndex() {
  // return request({
  //   url: "/app-dashboard/overview/other/price-index",
  //   method: "post",
  //   data: { data }
  // });
  return request({
    url: "/v3/iw-sales-analysis/overview/get-market-price",
    method: "get"
  });
}

// 获取价值echart
export function getPriceChart() {
  // return request({
  //   url: "/app-dashboard/overview/other/price-chart",
  //   method: "post",
  //   data: { data }
  // });
  return request({
    url: "/v3/iw-sales-analysis/overview/get-market-price-trend",
    method: "get"
  });
}
